import React, { useEffect, useRef, useState } from 'react'
import { getDateTimeWithAmPm } from '../utils/dateUtils'
import { safeJsonParse } from '../utils/jsonUtils'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import AutoModeIcon from '@mui/icons-material/AutoMode'
import {
   Box,
   Button,
   ButtonGroup,
   Chip,
   Divider,
   FormControl,
   Grid,
   IconButton,
   MenuItem,
   Modal,
   Select,
   TextField,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import toast from 'react-hot-toast'
import VisibilityIcon from '@mui/icons-material/Visibility'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import { BeatLoader } from 'react-spinners'
import axios from '../api/axios'
import { secureDownload } from '../utils/secureDownload'
import socket from '../socket'
import { compareRows } from '../utils/sortUtils'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { useLocation } from 'react-router-dom'

const SERVICE_LABELS = {
   EGR_OFF: 'EGR OFF',
   DPF_OFF: 'DPF OFF',
   DTC_OFF: 'DTC OFF',
   ADBLUE_OFF: 'AdBlue OFF',
   OPF_OFF: 'GPF/OPF OFF',
   POP_BANG: 'Pop & Bang',
   HARDCUT: 'Popcorn / Hardcut',
   E85_FLEX: 'E85 / Flex Fuel',
   DECAT: 'DECAT',
   VMAX_OFF: 'VMAX OFF',
}

const columns = [
   { id: 'orderId', label: 'ID', minWidth: 100 },
   { id: 'client', label: 'Client', minWidth: 100 },
   { id: 'vehicleType', label: 'Vehicle Type', minWidth: 150 },
   { id: 'buildYear', label: 'Build Year', minWidth: 100 },
   { id: 'HP', label: 'Power (HP)', minWidth: 100 },
   { id: 'status', label: 'Status', minWidth: 50 },
   { id: 'tuningType', label: 'Tuning Type', minWidth: 100 },
   { id: 'createdAt', label: 'Upload Date', minWidth: 100 },
   { id: 'action', label: 'Action', align: 'center' },
]

const style = {
   position: 'absolute',
   top: '50%',
   left: '50%',
   transform: 'translate(-50%, -50%)',
   width: '90vw',
   bgcolor: 'background.paper',
   border: '0px',
   borderRadius: 1,
   boxShadow: 24,
   p: 0,
}

export default function AdminUpload() {

   const location = useLocation()
   const [creditsData, setCreditsData] = useState([])
   const [account,setAccount] = useState(null);
   const [page, setPage] = useState(0)
   const [myID, setMyID] = useState('')
   const [rowsPerPage, setRowsPerPage] = useState(10)
   const [uploadBtnFlag, setUploadBtnFlag] = useState(true)
   const [creditBtnFlag, setCreditBtnFlag] = useState(true)
   const [allData, setAllData] = useState([])
   const [oneData, setOneData] = useState({
      orderId: '',
      userId: '',
      client: '',
      fileSize: [],
      fileType: [],
      fileName: [],
      fileRename: [],
      vehicleType: '',
      vehicleBrand: '',
      vehicleEngine: '',
      vehicleSeries: '',
      buildYear: '',
      HP: '',
      KW: '',
      transmission: '',
      VINnumber: '',
      tuningType: '',
      extras: '',
      message: '',
      note: '',
      status: '',
      createdAt: '',
      availableCredit: 0,
      chargedCredit: 0,
      permission: '',
   })
   const [status, setStatus] = useState('')
   const [note, setNote] = useState('')
   const [credit, setCredit] = useState(0)
   const [serviceid, setServiceID] = useState()
   const [pricingMode, setPricingMode] = useState('manual')
   const [open, setOpen] = useState(false)
   const [fileData, setFileData] = useState({})
   const [isLoading, setIsLoading] = useState(false)
   const inputElement = useRef('fileInput')
   /* file modal */
   const [fileOpen, setFileOpen] = useState(false)
   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
   const [searchTerm, setSearchTerm] = useState('');
   const [staleIds, setStaleIds] = useState([]);
   const [staleFilterActive, setStaleFilterActive] = useState(false);

   const handleSort = (columnId) => {
      setSortConfig((prevConfig) => {
         if (prevConfig.key === columnId) {
            return {
               key: columnId,
               direction: prevConfig.direction === 'asc' ? 'desc' : 'asc',
            };
         }
         return { key: columnId, direction: 'asc' };
      });
   };

   const filteredData = React.useMemo(() => {
      const base = staleFilterActive ? allData.filter(row => staleIds.includes(row.orderId)) : allData;
      if (!searchTerm) return base;

      const searchLower =
         String(searchTerm || '').trim().toLowerCase();

      const normalizedRegistrationSearch =
         searchLower.replace(/[\s-]/g, '');

      return base.filter((row) => {
         const columnMatch =
            columns.some((column) =>
               row[column.id]
                  ?.toString()
                  .toLowerCase()
                  .includes(searchLower)
            );

         const registrationMatch =
            String(row.registrationNumber || '')
               .trim()
               .toLowerCase()
               .replace(/[\s-]/g, '')
               .includes(normalizedRegistrationSearch);

         return columnMatch || registrationMatch;
      });
   }, [allData, searchTerm, staleFilterActive, staleIds]);

   const sortedData = React.useMemo(() => {
      if (sortConfig.key) {
         return [...filteredData].sort((a, b) =>
            compareRows(a, b, sortConfig.key, sortConfig.direction)
         );
      }
      return filteredData;
   }, [filteredData, sortConfig]);

   useEffect(()=>{
      const user = localStorage.getItem('user');
      if(user){
         let parse = safeJsonParse(user);
         setAccount(parse);
      }
   },[]);

   useEffect(() => {
      if(typeof serviceid === 'undefined') {
         // console.log("ServiceID is not defined")
         return
      }

      const obj = creditsData.find((item) => {
         return item.id === serviceid;
      })
      if(typeof obj !== 'undefined') {
         setCredit(obj.credit)
      }
   },[serviceid])
   
   const colorMap = {
      10: '#FFF4CC',
      25: '#FFE9DC',
      50: '#E7F0FF',
   };

   const getRowColor = (permission) => {
      if (permission?.toLowerCase().startsWith('user') && permission.length > 4) {
         const number = parseInt(permission.slice(4), 10);
         return colorMap[number] || 'transparent';
      }
      return 'transparent';
   };

   const getDiscountPercent = (permission) => {
      if (typeof permission === 'string' && permission.toLowerCase().startsWith('user') && permission.length > 4) {
         const number = parseInt(permission.slice(4).trim(), 10);
         return isNaN(number) ? 0 : number;
      }
      return 0;
   };  

   const getDiscountedPrice = (number, permission) => {
      const permissionNumber = getDiscountPercent(permission);
      if (permissionNumber > 0) {
         return number - (number * (permissionNumber / 100));
      }
      return number;
   };   

   const handleChangePage = (event, newPage) => {
      setPage(newPage)
   }

   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(+event.target.value)
      setPage(0)
   }

   const paginatedData = sortedData.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
   );

   const handleFileload = () => {
      inputElement.current.click()
   }

   const getFile = async (e) => {
      setFileData(e.target.files[0])
   }

   const upload = async () => {
      if (!uploadBtnFlag)
         if (!fileData.name) {
            toast.error('Select a file')
            return
         }
      if (!status) {
         toast.error('Select a status')
         return
      }
      if (!creditBtnFlag && pricingMode === 'manual') {
         if (typeof serviceid === 'undefined' || serviceid === null) {
            toast.error('Select a manual credit charge or use Auto price')
            return
         }
      }
      if (!isLoading) {
         setIsLoading(true)
         try {
            const autoQuotedCredit = Number(oneData?.pricing?.quotedCredit)
            const hasAutoPrice =
               oneData?.pricing?.autoPriced === true &&
               Number.isFinite(autoQuotedCredit)

            let cost =
               pricingMode === 'auto' && hasAutoPrice
                  ? autoQuotedCredit
                  : getDiscountedPrice(credit, oneData.permission);
            if (status === 'completed') {
               let params = new FormData()
               const data = {
                  id: oneData._id,
                  userId: oneData.userId,
                  orderId: oneData.orderId,
                  status,
                  note,
                  credit: cost,
                  pricingMode,
                  priceId: pricingMode === 'manual' ? serviceid : null,
                  date: getDateTimeWithAmPm(),
               }
               params.append('file', fileData)
               params.append('data', JSON.stringify(data))
               await axios
                  .post(`updateUpload`, params)
                  .then((result) => {
                     if (result.data.status) {
                        toast.success(result.data.data)
                        getRequests()
                        setOpen(false)
                        setFileData('')
                        setStatus('')
                        setNote('')
                        setServiceID()
                        setPricingMode('manual')
                        setCredit(0)
                        socket.emit('reply', {
                           from: myID,
                           to: oneData.userId,
                           orderId: oneData.orderId,
                        })
                        setIsLoading(false)
                     } else {
                        toast.error(result.data.data)
                        setIsLoading(false)
                     }
                  })
            } else {
               const data = {
                  id: oneData._id,
                  userId: oneData.userId,
                  status,
                  note,
                  credit: cost,
                  pricingMode,
                  priceId: pricingMode === 'manual' ? serviceid : null,
                  orderId: oneData.orderId,
               }
               await axios
                  .post(`uploadStatusSave`, {
                     data,
                  })
                  .then((result) => {
                     if (result.data.status) {
                        toast.success(result.data.data)
                        getRequests()
                        setOpen(false)
                        setStatus('')
                        setNote('')
                        setServiceID()
                        setPricingMode('manual')
                        setCredit(0)
                        socket.emit('reply', {
                           from: myID,
                           to: oneData.userId,
                           orderId: oneData.orderId,
                        })
                        setIsLoading(false)
                     } else {
                        toast.error(result.data.data)
                        setIsLoading(false)
                     }
                  })
            }
         } catch (error) {
            if (process.env.REACT_APP_MODE) console.log(error)

            toast.error(
               error?.response?.data?.data ||
               'Could not update request'
            )

            setIsLoading(false)
         }
      } else {
         toast.error('Loading...')
      }
   }

   const getOneRequest = async (id) => {
      try {
         await axios
            .post(`getOneRequest`, { id })
            .then((result) => {
               if (result.data.status) {
                  let data = result.data.data
                  data.availableCredit = result.data.available
                  data.chargedCredit = result.data.charged
                  data.userExists = result.data.userExists
                  setOneData(data)
                  setStatus(data.status)
                  setNote(data.note)
                  setServiceID()

                  const autoCredit = Number(data?.pricing?.quotedCredit)
                  const canUseAutoPrice =
                     data?.pricing?.autoPriced === true &&
                     Number.isFinite(autoCredit)

                  if (canUseAutoPrice && Number(data.chargedCredit || 0) === 0) {
                     setPricingMode('auto')
                     setCredit(autoCredit)
                  } else {
                     setPricingMode('manual')
                     setCredit(0)
                  }

                  setOpen(true)
               } else {
                  toast.error(result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
      }
   }

   const handleClose = () => setOpen(false)

   const getRequests = async () => {
      try {
         await axios
            .post(`getRequests`)
            .then((result) => {
               if (result.data.status) {
                  setAllData(result.data.data)
               } else {
                  toast.error(result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
      }
   }

   const changeStatus = async (id, userId, orderId) => {
      try {
         await axios
            .post(`changeStatus`, { id })
            .then((result) => {
               if (result.data.status) {
                  toast.success(result.data.data)
                  socket.emit('reply', {
                     from: myID,
                     to: userId,
                     orderId,
                  })
                  getRequests()
               } else {
                  toast.error(result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
      }
   }

   const deleteFile = () => {
      setFileData({})
      setFileOpen(false)
   }

   const getAllPrice = async () => {
      try {
         await axios
            .post(`getAllPrice`)
            .then((result) => {
               if (result) {
                  let data = result.data.map((item)=>{
                     return {credit: item.credit, service: item.service, id: item._id}
                  })
                  data.unshift({credit: 0, service: "No charge", id: 0})
                  // console.log(data)
                  setCreditsData(data)
               } else {
                  toast.error('Internal server error')
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
      }
   }

   useEffect(() => {
      const ids = location.state?.staleOrderIds
      if (ids && ids.length > 0) {
         setStaleIds(ids)
         setStaleFilterActive(true)
      }
      getRequests()
      getAllPrice()
   }, [])

   useEffect(() => {
      if (status === 'completed') {
         setUploadBtnFlag(false)
         setCreditBtnFlag(false)
      } else if (status === 'in-progress') {
         setUploadBtnFlag(true)
         setCreditBtnFlag(true)
      } else {
         setUploadBtnFlag(true)
         setCreditBtnFlag(true)
      }
   }, [status])

   useEffect(() => {
      if (account) {
         setMyID(account?._id)
      }
   }, [account])

   useEffect(() => {
      if (fileData?.name) setFileOpen(true)
      else setFileOpen(false)
   }, [fileData])

   return (
      <Paper
         sx={{
            width: '100%',
            overflow: 'hidden',
            p: 3,
            overflowY: 'overlay',
         }}
      >
         <div style={{marginBottom: '10px'}}>Requests</div>
         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <TextField
               label="Search and filter"
               variant="outlined"
               sx={{ width: '300px' }}
               value={searchTerm}
               onChange={(e) => setSearchTerm(e.target.value)}
            />
            {staleIds.length > 0 && (
               <Chip
                  label={`Stale (${staleIds.length})`}
                  size="small"
                  onClick={() => setStaleFilterActive(prev => !prev)}
                  color={staleFilterActive ? 'warning' : 'default'}
                  variant={staleFilterActive ? 'filled' : 'outlined'}
               />
            )}
         </Box>
         <TableContainer
            sx={{
               mt: 2,
            }}
         >
            <Table stickyHeader aria-label="sticky table">
               <TableHead>
                  <TableRow>
                     {columns.map((column) => (
                        <TableCell
                           key={column.id}
                           align={column.align}
                           style={{
                              minWidth: column.minWidth,
                              backgroundColor: '#163A5F',
                              color: 'white',
                              cursor: 'pointer',
                           }}
                           onClick={() => handleSort(column.id)}
                        >
                           {column.label}{' '}
                           {sortConfig.key === column.id && (sortConfig.direction === 'asc' ? 'â–²' : 'â–¼')}
                        </TableCell>
                     ))}
                  </TableRow>
               </TableHead>
               <TableBody>
                  {paginatedData.map((row) => (
                     <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row._id}
                        style={{ backgroundColor: getRowColor(row.permission) }}
                     >
                        {columns.map((column) => {
                           let value = ''
                           if (column.id === 'buildYear') {
                              const d = new Date(row.buildYear)
                              value = d.getFullYear()
                           } else {
                              value = row[column.id]
                           }
                           return (
                              <TableCell
                                 key={column.id}
                                 align={column.align}
                              >
                                 {column.id === 'action' ? (
                                    <ButtonGroup
                                       variant="outlined"
                                       aria-label="outlined button group"
                                    >
                                       {row.status.toLowerCase() === 'requested' ? (
                                          <IconButton
                                             onClick={() =>
                                                changeStatus(
                                                   row._id,
                                                   row.userId,
                                                   row.orderId
                                                )
                                             }
                                             color="primary"
                                             aria-label="add to shopping cart"
                                          >
                                             <AutoModeIcon />
                                          </IconButton>
                                       ) : (
                                          <></>
                                       )}
                                       <IconButton
                                          onClick={() =>
                                             getOneRequest(row._id)
                                          }
                                          color="primary"
                                          aria-label="add to shopping cart"
                                       >
                                          <VisibilityIcon />
                                       </IconButton>
                                    </ButtonGroup>
                                 ) : column.id === 'status' ? (
                                     value.toLowerCase() === 'in-progress' ? "In progress" : value
                                 ) : (
                                    value
                                 )}
                              </TableCell>
                           );
                        })}
                     </TableRow>
                  ))}
               </TableBody>
            </Table>
         </TableContainer>
         <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
         />
         <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
         >
            <Box sx={style}>
               <Box
                  sx={{
                     px: 3,
                     py: 1,
                     bgcolor: '#163A5F',
                     borderRadius: 1,
                     color: 'white',
                     display: 'flex',
                     alignItems: 'center',
                     position: 'fixed',
                     width: '100%',
                  }}
               >
                  <Box>View Complete Service Request</Box>
                  <Box sx={{ flex: '1' }}></Box>
                  <Box>
                     <IconButton
                        onClick={() => {
                           handleClose()
                        }}
                     >
                        <CloseIcon sx={{ color: 'white' }} />
                     </IconButton>
                  </Box>
               </Box>
               <Box
                  sx={{
                     p: 3,
                     mt: 9,
                     height: '70vh',
                     overflowY: 'overlay',
                  }}
               >
                  <Box>
                     <Grid
                        container
                        spacing={{ xs: 2, md: 3 }}
                        columns={{ xs: 4, sm: 8, md: 12 }}
                     >
                        <Grid
                           item
                           xs={12}
                           sm={6}
                           md={6}
                           sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '20px',
                           }}
                        >
                           <Box
                              sx={{
                                 display: 'flex',
                                 justifyContent: 'flex-start',
                                 border: '1px dotted',
                                 borderRadius: '20px',
                                 flexDirection: 'column',
                                 p: '30px',
                                 gap: '10px',
                                 alignItems: 'center',
                              }}
                           >
                              {fileOpen ? (
                                 <Box className="select-file" mt={4}>
                                    <Box className="file-group-box">
                                       <Box className="upload-img-box">
                                          <UploadFileIcon className="upload-img-icon" />
                                       </Box>
                                       <Box className="file-info">
                                          <Box>
                                             <Box className="filename-string">
                                                {fileData?.name}
                                             </Box>
                                             <Box>
                                                {(
                                                   fileData?.size / 1000000
                                                ).toFixed(4)}{' '}
                                                MB
                                             </Box>
                                          </Box>
                                       </Box>
                                    </Box>
                                    <Box className="close-img-box">
                                       <HighlightOffIcon
                                          className="close-img-icon"
                                          onClick={() => deleteFile()}
                                       />
                                    </Box>
                                 </Box>
                              ) : (
                                 <>
                                    <Box>
                                       <CloudUploadIcon
                                          sx={{
                                             color: '#163A5F',
                                             fontSize: '70px',
                                          }}
                                       />
                                    </Box>
                                    <Box>Drag and drop your file here</Box>
                                    <Box>or</Box>
                                 </>
                              )}

                              <Box>
                                 <input
                                    ref={inputElement}
                                    type="file"
                                    style={{ display: 'none' }}
                                    onChange={(e) => getFile(e)}
                                 />
                                 <Button
                                    variant="outlined"
                                    sx={{
                                       border: '1px solid #163A5F',
                                       borderRadius: '12px',
                                       color: '#163A5F',
                                    }}
                                    disabled={uploadBtnFlag}
                                    onClick={handleFileload}
                                 >
                                    Browse File
                                 </Button>
                              </Box>
                           </Box>
                           <Box>
                              Available Credits: {oneData.availableCredit}
                           </Box>
                           <Box>Charged Credits: {oneData.chargedCredit}</Box>
                           <Box>
                              Update Status
                              <FormControl fullWidth size="small">
                                 <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                 >
                                    <MenuItem value="completed">
                                       Completed
                                    </MenuItem>
                                    <MenuItem value="in-progress">
                                       In progress
                                    </MenuItem>
                                    <MenuItem value="cancelled">
                                       Cancelled
                                    </MenuItem>
                                 </Select>
                              </FormControl>
                           </Box>
                           <Box>
                              Note
                              <TextField
                                 placeholder={
                                    oneData.chargedCredit > 0
                                       ? oneData.note === '' ? '' :
                                       `X-note : ${oneData.note}` :
                                       'Add a short note'
                                 }
                                 variant="outlined"
                                 size="small"
                                 fullWidth
                                 value={note}
                                 onChange={(e) => setNote(e.target.value)}
                              />
                           </Box>
                           <Box>
                              {oneData?.pricing?.autoPriced &&
                                 Number.isFinite(
                                    Number(oneData?.pricing?.quotedCredit)
                                 ) && (
                                    <Box
                                       sx={{
                                          mb: 2,
                                          p: 2,
                                          border: '1px solid #d9e2ec',
                                          borderRadius: 1,
                                          backgroundColor:
                                             pricingMode === 'auto'
                                                ? '#f0f7ff'
                                                : '#f8fafc',
                                       }}
                                    >
                                       <Box
                                          sx={{
                                             display: 'flex',
                                             justifyContent: 'space-between',
                                             alignItems: 'center',
                                             gap: 2,
                                             mb: 1,
                                          }}
                                       >
                                          <Box sx={{ fontWeight: 700 }}>
                                             Auto price
                                          </Box>

                                          {pricingMode === 'auto' && (
                                             <Chip
                                                size="small"
                                                label="Selected"
                                                color="primary"
                                             />
                                          )}
                                       </Box>

                                       {oneData?.pricing?.standard && (
                                          <Box
                                             sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                gap: 2,
                                             }}
                                          >
                                             <Box>
                                                {oneData.pricing.standard.service}
                                             </Box>
                                             <Box>
                                                {oneData.pricing.standardCredit} credits
                                             </Box>
                                          </Box>
                                       )}

                                       {(oneData?.pricing?.specials || []).map(
                                          (item) => (
                                             <Box
                                                key={item.priceId}
                                                sx={{
                                                   display: 'flex',
                                                   justifyContent: 'space-between',
                                                   gap: 2,
                                                   mt: 0.5,
                                                }}
                                             >
                                                <Box>{item.service}</Box>
                                                <Box>+{item.credit} credits</Box>
                                             </Box>
                                          )
                                       )}

                                       {Number(
                                          oneData?.pricing?.discountPercent || 0
                                       ) > 0 && (
                                          <Box
                                             sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                gap: 2,
                                                mt: 0.5,
                                             }}
                                          >
                                             <Box>
                                                Account discount (
                                                {oneData.pricing.discountPercent}%)
                                             </Box>
                                             <Box>
                                                -{oneData.pricing.discountCredit} credits
                                             </Box>
                                          </Box>
                                       )}

                                       <Divider sx={{ my: 1 }} />

                                       <Box
                                          sx={{
                                             display: 'flex',
                                             justifyContent: 'space-between',
                                             gap: 2,
                                             fontWeight: 700,
                                          }}
                                       >
                                          <Box>Charge</Box>
                                          <Box>
                                             {oneData.pricing.quotedCredit} credits
                                          </Box>
                                       </Box>

                                       <Button
                                          variant={
                                             pricingMode === 'auto'
                                                ? 'contained'
                                                : 'outlined'
                                          }
                                          size="small"
                                          fullWidth
                                          disabled={
                                             creditBtnFlag ||
                                             Number(oneData.chargedCredit || 0) > 0
                                          }
                                          sx={{ mt: 1.5 }}
                                          onClick={() => {
                                             setPricingMode('auto')
                                             setServiceID()
                                             setCredit(
                                                Number(
                                                   oneData.pricing.quotedCredit
                                                )
                                             )
                                          }}
                                       >
                                          {Number(oneData.chargedCredit || 0) > 0
                                             ? 'Already charged'
                                             : 'Use auto price'}
                                       </Button>
                                    </Box>
                                 )}

                              <Box sx={{ mb: 0.5, fontWeight: 600 }}>
                                 Manual override
                              </Box>

                              <Select
                                 labelId="demo-simple-select-filled-label"
                                 id="demo-simple-select-filled"
                                 size="small"
                                 fullWidth
                                 disabled={creditBtnFlag}
                                 value={
                                    typeof serviceid === 'undefined'
                                       ? ''
                                       : serviceid
                                 }
                                 displayEmpty
                                 onChange={(e) => {
                                    setPricingMode('manual')
                                    setServiceID(e.target.value)
                                 }}
                              >
                                 <MenuItem value="" disabled>
                                    Select manual charge
                                 </MenuItem>

                                 {creditsData.map((item, key) => {
                                    return (
                                       <MenuItem key={key} value={item.id}>
                                          {item.service +
                                             ' (' +
                                             getDiscountedPrice(
                                                item.credit,
                                                oneData?.permission
                                             ) +
                                             ' credits)'}
                                       </MenuItem>
                                    )
                                 })}
                              </Select>
                           </Box>
                           <Box>
                              <Button
                                 variant="contained"
                                 size="small"
                                 fullWidth
                                 endIcon={<ArrowForwardIcon />}
                                 onClick={upload}
                              >
                                 {isLoading ? (
                                    <BeatLoader color="#fff" size={10} />
                                 ) : (
                                    'Upload'
                                 )}
                              </Button>
                           </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                           <Box>
                              <Box
                                 sx={{
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                 }}
                              >
                                 Request From ({oneData?.client})
                              </Box>
                              {oneData?.userExists === false &&
                                <Box sx={{ color: 'warning.main', fontSize: '0.85em', mt: '4px' }}>
                                  AnvÃ¤ndarkontot finns inte lÃ¤ngre i systemet.
                                </Box>
                              }
                              <Divider />
                              <Grid lineHeight={'4px'}>
                                 <Grid
                                   container
                                   spacing={{ xs: 2, md: 3 }}
                                   columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                   <Grid item xs={12} sm={6} md={6}>
                                     <Box sx={{ my: '20px' }}>Name:</Box>
                                   </Grid>
                                   <Grid item xs={12} sm={6} md={6}>
                                     <Box sx={{
                                          backgroundColor: getRowColor(oneData?.permission),
                                          height: "100%",
                                          display: "flex",
                                          alignItems: "center",
                                          position: "relative",
                                          "::before": {
                                            content: '""',
                                            position: "absolute",
                                            left: "-7px",
                                            top: 0,
                                            bottom: 0,
                                            width: "7px",
                                            backgroundColor: getRowColor(oneData?.permission),
                                          },
                                       }}>
                                       {oneData?.client}
                                       {oneData?.permission && oneData.permission.includes('user') ?
                                        getDiscountPercent(oneData.permission) > 0 ?
                                        ` (${getDiscountPercent(oneData.permission)} %)`: '' : ''}
                                     </Box>
                                   </Grid>
                                 </Grid>
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          Vehicle Type:
                                       </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          {oneData?.vehicleType}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          Vehicle Series:
                                       </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          {oneData?.vehicleSeries}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          Build Year:
                                       </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          {new Date(
                                             oneData?.buildYear
                                          ).getFullYear()}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>HP:</Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          {oneData?.HP}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>KW:</Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          {oneData?.KW}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          Transmission:
                                       </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          {oneData?.transmission}
                                       </Box>
                                    </Grid>
                                 </Grid>

                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          Registration Number:
                                       </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          {oneData?.registrationNumber || ''}
                                       </Box>
                                    </Grid>
                                 </Grid>

                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          VINnumber#:
                                       </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          {oneData?.VINnumber}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          Tuning Type:
                                       </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          {oneData?.tuningType}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>Services:</Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          {Array.isArray(oneData?.requestedServices) &&
                                          oneData.requestedServices.length > 0
                                             ? oneData.requestedServices
                                                  .map(
                                                     (key) =>
                                                        SERVICE_LABELS[key] || key
                                                  )
                                                  .join(', ')
                                             : oneData?.extras}
                                       </Box>
                                    </Grid>
                                 </Grid>
                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          Work Status:
                                       </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>
                                          {oneData?.status.toLowerCase() === 'in-progress' ? "In progress" :
                                           oneData?.status.charAt(0).toUpperCase() + oneData?.status.slice(1)}
                                       </Box>
                                    </Grid>
                                 </Grid>

                                 <Grid
                                    container
                                    spacing={{ xs: 2, md: 3 }}
                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                 >
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box sx={{ my: '20px' }}>Message:</Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                       <Box
                                          sx={{
                                             my: '20px',
                                             overflowWrap: 'break-word',
                                             lineHeight: '20px',
                                          }}
                                       >
                                          {oneData?.message}
                                       </Box>
                                    </Grid>
                                 </Grid>
                              </Grid>

                              <Grid
                                 container
                                 spacing={{ xs: 2, md: 3 }}
                                 columns={{ xs: 4, sm: 8, md: 12 }}
                              >
                                 <Grid item xs={12} sm={12} md={12}>
                                    <Box
                                       sx={{
                                          my: '20px',
                                          fontSize: '20px',
                                          fontWeight: '600',
                                       }}
                                    >
                                       Upload
                                    </Box>
                                    <ul>
                                       <li className="file-admin-download-name">
                                          <a
                                             href="#"
                                             onClick={(e) => {
                                                e.preventDefault()
                                                secureDownload(
                                                   'fileService',
                                                   oneData?.fileRename[0],
                                                   oneData?.fileName[0]
                                                ).catch(() => {
                                                   toast.error('Download failed')
                                                })
                                             }}
                                          >
                                             {oneData?.fileName[0]}
                                          </a>
                                       </li>
                                    </ul>
                                 </Grid>
                              </Grid>
                              <Grid
                                 container
                                 spacing={{ xs: 2, md: 3 }}
                                 columns={{ xs: 4, sm: 8, md: 12 }}
                              >
                                 <Grid item xs={12} sm={12} md={12}>
                                    <Box
                                       sx={{
                                          my: '20px',
                                          fontSize: '20px',
                                          fontWeight: '600',
                                       }}
                                    >
                                       Uploaded by Support team
                                    </Box>
                                    <ul>
                                       {oneData?.fileName.map((item, ind) =>
                                          ind === 0 ? (
                                             <p key={ind}></p>
                                          ) : (
                                             <li
                                                key={ind}
                                                className="file-admin-download-name"
                                             >
                                                <a
                                                   href="#"
                                                   onClick={(e) => {
                                                      e.preventDefault()
                                                      secureDownload(
                                                         'fileService',
                                                         oneData?.fileRename[ind],
                                                         item
                                                      ).catch(() => {
                                                         toast.error('Download failed')
                                                      })
                                                   }}
                                                >
                                                   {item}
                                                </a>
                                             </li>
                                          )
                                       )}
                                    </ul>
                                 </Grid>
                              </Grid>
                           </Box>
                        </Grid>
                     </Grid>
                  </Box>
               </Box>
            </Box>
         </Modal>
      </Paper>
   )
}

